<template>
<div v-if="can('read', 'user account')" class="user-list">
    <div class="search-bar">
        <!-- <router-link :to="{path: '/employee/add-employee', query: {empid :  totalRecord } }" target="_blank"> 
            <Button label="Add" class="p-button-sm" icon="pi pi-plus-circle" />
        </router-link> -->
        <Button v-if="can('create', 'user account')" label="Add User" class="p-button-sm" @click="openUserAccountForm('add')"/>
    </div>   
    
    <div class="content-section implementation">
        <div class="userlist-datatable card">
            <DataTable
                :value="usersList"
                responsiveLayout="scroll"
                scrollHeight="300px"
                v-model:selection="selectedUser" 
                selectionMode="single"
                @rowSelect="onRowSelect"
                dataKey="id"
            >
                <Column field="id" header="ID" ></Column>
                <Column field="username" header="Username" :style="{'min-width':'130px'}"></Column>
                <Column field="password" header="Password" :style="{'min-width':'130px'}">
                    <template #body>
                        {{"&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;"}}
                    </template>
                </Column>
                <Column field="user_role" header="User role" :style="{'min-width':'130px', 'max-width':'60px'}"></Column>
                <Column field="user_profile" header="User profile" :style="{'min-width':'130px', 'max-width':'80px'}"></Column>
                <Column field="acc_status" header="Account status" :style="{'min-width':'130px', 'max-width':'70px'}">
                    <template #body="slotProps">
                        <Tag class="custom-tag p-mr-2" :severity="slotProps.data.acc_status == 'active' ? 'success' : 'danger'" :value="slotProps.data.acc_status.toUpperCase()"></Tag>
                    </template>
                </Column>

                <Column :exportable="false" :style="{'min-width':'90px', 'padding':'0.4rem 0.5rem', 'text-align':'right'}">
                    <template #body="slotProps">
                        <!-- <Button icon="pi pi-pencil" class="p-button-rounded p-button-outlined p-button-success small-datatable-button p-mr-2" @click="updateUserForm(slotProps.index)"/> -->
                        <Button v-if="can('update', 'user account')" icon="pi pi-pencil" class="p-button-rounded p-button-outlined p-button-success small-datatable-button p-mr-2" @click="openUserAccountForm('update', slotProps.index)"/>
                        <Button v-if="can('delete', 'user account')" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger small-datatable-button p-mr-2" @click="confirmDeleteUser(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </div>
        
        <Dialog v-model:visible="displayUserAccountForm" :style="{width: '40rem'}" :modal="true">
            <template #header>
                <h5 v-if="!showMsg.isMsgShow" style="margin: 0px">{{dialogHeader}}</h5>
                <InlineMessage v-if="showMsg.isMsgShow" style="padding: 4px 10px" :severity="showMsg.severity">{{showMsg.content}}</InlineMessage>
            </template>
            <UserAccountForm :FormType="form_type"  @RefreshUserAccountList="getUserAccount" />
        </Dialog>
    
        <div class="permission-list">
            <RoleManagement :ShowAssignButtonRoleList="true" @RefreshUserAccountList="getUserAccount" />
        </div>
    </div>
</div>
</template>

<script>
import { ref, onMounted, computed, inject } from 'vue'
import { useStore } from 'vuex';
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import { useAbility } from '@casl/vue';

import RoleManagement from './RoleManagement.vue';
import UserAccountForm from '../components/UserAccountForm.vue';
import UserAccountService from '../service/UserAccountService';

export default {
    setup() {
        const { can } = useAbility()
        const store = useStore()
        const toast = useToast()
        const confirm = useConfirm()

        const showMsg = computed(() => store.state.showMsg)

        let dialogHeader = ref('')
        let selectedUser = ref()
        const displayUserAccountForm = ref(false);
        let form_type = ref('')
        let usersList = ref([])
        const userIs = inject('userIs')
        
        //On Created
        const userAccountService = ref(new UserAccountService());

        onMounted(() => {
            getUserAccount();
        })

        const onRowSelect = (event) => {
            store.dispatch('useraccount_info', {id: event.data.id}) //userAccount store

            //Store role id to check if it's assigned in user_role table
            store.dispatch('user_roleID', event.data.user_role_id) //userAccount store
        }
        
        const openUserAccountForm = (formtype, userindex) => {
            displayUserAccountForm.value = true;
            form_type.value = formtype
            selectedUser.value = usersList.value[userindex]

            let linked_profile = []
            for (const userprofile of usersList.value) {
                linked_profile = [...linked_profile, {profile: userprofile.user_profile}]
            }
            store.dispatch('linked_userprofile', linked_profile) //Use to check if profile already linked

            if(formtype == 'add'){
                dialogHeader.value = 'Add User'
            } else {
                dialogHeader.value = 'Update User'
                store.dispatch('useraccount_info', usersList.value[userindex]) //Save user account data in store to use in update form
            }
        };

        const getUserAccount = () =>{
            userAccountService.value.getUserAccount().then((data) => {
                if(!data.errorResponse) {
                    //IF USE IS NOT AN ADMIN, WILL NOT SHOW USER ACCOUNT THAT HAS ADMIN ROLE
                    if(userIs.type != 'Administrator') {
                        data = data.filter(item => item.user_role != 'Administrator')
                    }

                    usersList.value = data
                } else {
                    toast.add({severity:'warn', summary: 'Error ' + data.status, detail: data.errorResponse, life: 5000});
                }
            });
        }

        const confirmDeleteUser = (data) => {
            confirm.require({
                message: 'Are you sure you want to delete "'+ data.username +'"?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: () => {
                    const user_id = data.id
                    userAccountService.value.deleteUserAccount(user_id).then((data) => {
                        if(!data.errorResponse){
                            usersList.value = usersList.value.filter(val => val.id !== user_id);
                        } else {
                            toast.add({icon: 'pi-times-circle', severity:'error', summary: 'Delete Error ' + data.status, detail: data.errorResponse, life: 5000});        
                        }
                    })
                }
            });
        }

        return {
            can,
            usersList,
            selectedUser,
            displayUserAccountForm,
            dialogHeader,
            form_type,
            
            showMsg,
            
            getUserAccount,
            confirmDeleteUser,
            onRowSelect,
            openUserAccountForm,
        }
    },
    components:{
        UserAccountForm,
        RoleManagement,
    }
}
</script>

<style lang="css" scoped>
.userlist-datatable {
    height: 320px;
}

.custom-tag.p-tag{
    font-weight: 500;
}

.permission-list{
    margin-top: 2rem
}
</style>